function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.5 9c-1.655 0-3-1.345-3-3s1.345-3 3-3 3 1.345 3 3-1.345 3-3 3zm21 0c-1.655 0-3-1.345-3-3s1.345-3 3-3 3 1.345 3 3-1.345 3-3 3zm1.5 1.5c1.655 0 3 1.345 3 3V15c0 .83-.67 1.5-1.5 1.5h-3.094a6.857 6.857 0 00-3.52-5.128A2.991 2.991 0 0124 10.5h3zm-12 0a5.247 5.247 0 01-5.25-5.25A5.247 5.247 0 0115 0a5.247 5.247 0 015.25 5.25A5.247 5.247 0 0115 10.5zm3.6 1.5c2.981 0 5.4 2.419 5.4 5.4v1.35A2.25 2.25 0 0121.75 21H8.25A2.25 2.25 0 016 18.75V17.4c0-2.981 2.419-5.4 5.4-5.4h.39a7.4 7.4 0 003.21.75 7.384 7.384 0 003.21-.75h.39zm-10.486-.628A6.874 6.874 0 004.589 16.5H1.5C.67 16.5 0 15.83 0 15v-1.5c0-1.655 1.345-3 3-3h3c.825 0 1.57.333 2.114.872z"
});

var SvgGroupIcon = function SvgGroupIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 30 21"
  }, props), _ref);
};

export default SvgGroupIcon;